import { component as defineComponent } from 'flightjs';
import { findIndex, merge } from 'lodash';

const updateDesignCollectionReactData = function () {
    this.after('initialize', function () {
        this.on(document, 'dataEntryUpdated', function (e, data) {
            this.updateCollectionForDesign(data);
        });
    });

    this.updateCollectionForDesign = function (design) {
        var reactData = this.$node.data('design-collection');
        var designIndexToUpdate;
        var designToUpdate;

        if (!reactData._embedded || !design) {
            return;
        }

        designIndexToUpdate = this.getDesignIndexByEntryId(
            reactData._embedded.designs,
            design.entry_id
        );
        designToUpdate = reactData._embedded.designs[designIndexToUpdate];

        if (designToUpdate) {
            merge(designToUpdate, design);

            this.$node.data('design-collection', reactData);
            this.trigger('dataDesignCollectionDesignUpdated', design);
        }
    };

    this.getDesignIndexByEntryId = function (designs, designId) {
        return findIndex(designs, function (design) {
            return design && parseInt(design.entry_id, 10) === parseInt(designId, 10);
        });
    };
};

export default defineComponent(updateDesignCollectionReactData);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/update-design-collection-react-data.js